import PropTypes from 'prop-types';

// ConnectedFacebook Component
const ConnectedFacebook = ({ handleNextStep }) => (
  <>
    <div className="boarding-title" style={{ marginTop: '40px' }}>
      Your Facebook account is now connected with Stockbit!
    </div>

    {/* skip: go to discover people */}
    <div
      role="button"
      tabIndex={-1}
      className="boarding-button-next"
      onClick={handleNextStep}
      onKeyDown={handleNextStep}
    >
      Next
    </div>
  </>
);

ConnectedFacebook.propTypes = {
  handleNextStep: PropTypes.func,
};

ConnectedFacebook.defaultProps = {
  handleNextStep: () => {},
};

export default ConnectedFacebook;
